/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'delete': {
    width: 21,
    height: 23,
    viewBox: '0 0 21 23',
    data: '<path pid="0" _fill="#008cff" d="M16.869 22.65H4.477a.875.875 0 01-.863-.81L2.18 5.176H.375V3.4h6.037V1.478C6.412.663 7.06 0 7.857 0h5.661c.797 0 1.445.663 1.445 1.478V3.4H21v1.775h-1.835L17.732 21.84a.875.875 0 01-.863.81zM5.27 20.876h10.805l1.35-15.701H3.921zm9.259-2.57l-1.732-.065.375-10.497 1.732.065zm-7.683 0L6.47 7.809l1.732-.065.376 10.497zm4.708-.032H9.821V7.777h1.733zm1.675-16.5H8.145V3.4h5.084z"/>'
  }
})
